module.exports = __webpack_public_path__ + "img/logo1.05fd99ef.png";